import React, {useState, useEffect, useRef} from 'react';
import {Link, useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAddressCard, faCheckSquare} from "@fortawesome/free-solid-svg-icons";
import PartnerSubMenu from "../../../components/partners/ui/PartnerSubMenu";
import BackButton from "../../../components/common/ui/BackButton";
import RefreshButton from "@paylani/paylani-react-packages/dist/common/ui/RefreshButton";
import MasterScreenMain from "../../../MasterScreenMain";
import PartnerService from "../../../components/partners/services/PartnerService";
import BatchService from "../../../components/batches/services/BatchService";
import DateTime from "@paylani/paylani-react-packages/dist/common/formatting/DateTime";
import "./Insights.css";
import DialogBox from "../../../components/common/ui/dialog-box/DialogBox";
import DialogBoxController from "../../../components/common/ui/dialog-box/DialogBoxController";
import {Checkbox} from "@mui/material";
import PagerController from "../../../components/common/ui/pager/PagerController";
import Pager from "../../../components/common/ui/pager/Pager";

const AmericanExpressScreen = (props) => {
    let _;
    const {merchantId, partnerId} = useParams();
    const empty = "00000000-0000-0000-0000-000000000000";
    const [partner, setPartner] = useState(PartnerService.instance.partnerMap[partnerId] || null);
    const [results, setResults] = useState([] || null);
    
    const [seController, setSeController] = useState(new DialogBoxController((<>Edit SE Number</>), null)); 
    const [currentPage, setCurrentPage] = useState(0);
    const pagerController = useRef(new PagerController(setCurrentPage, 12)).current;
    const [reSubmitCheckState, setReSubmitCheckState] = useState(false);
    const seNumberRef = useRef();
    
    const getPartnerAsync = async (force) => {
        if (!force && !!partner?.id) return partner;
        
        const p = await PartnerService.instance.getPartnerAsync(partnerId);
        
        if (!!p?.id) {
            setPartner(p);
            return p;
        }
        
        return null;
    };
    
    const getAmexResultsAsync = async (force = true) => {
        const results = await BatchService.instance.getPartnerBatchResultsAsync(partnerId);
        if (results !== null) setResults(results);

        return results;
    };
    
    const getAllAsync = async (force = false) => {
        await Promise.all([
            getPartnerAsync(force),
            getAmexResultsAsync(force)
        ]).then((values) => {
            const p = values[0];
        });
    };
    
    const toggleCheckBox = () => {
        console.log(reSubmitCheckState);
        setReSubmitCheckState(!reSubmitCheckState);
    };
    
    const createSeEditForm = (result, index) => {
        const checkboxElement = reSubmitCheckState ? (<FontAwesomeIcon icon={faCheckSquare} />) : (<FontAwesomeIcon icon={faCheckSquare} />);
        return (<div className={"form se-form"}>
            <div className={"form-group"}>
                <label>American Express SE Number:</label>
                <input autoFocus={true} type={"text"} ref={seNumberRef} defaultValue={result?.txnId} />
            </div>
            
            <div className={"form-group checkbox"}>
                <a onClick={() => toggleCheckBox()}>{ checkboxElement }</a>
                Re-Submit Batch
            </div>
        </div>);
    };
    
    const promptForSeEdit = (result, index) => {
        const body = createSeEditForm(result, index);
        seController.setBody(body);
        seController.setPayload({ index: index, result: result });
        seController.open();
    };
    
    const onSeUpdatedAsync = async (e) => {
        const data = seController.payload;
        const result = data?.result;
        const index = data?.index || -1;
        const seNumber = seNumberRef.current?.value || null;
        
        console.warn("New SE Number: " + seNumber);
        console.warn("ResultId: " + result?.id);
        console.warn("Index: " + index);
        
        const rsp = await BatchService.instance.updateAmexBatchResultSeNumberAsync(result?.id, seNumber);
        const resubmitRsp = resubmitBatchAsync()
        await getAmexResultsAsync(true);

        return 800;
    };

    const resubmitBatchAsync = async (batchId) => {
        const batchIds = [batchId];

        await BatchService.instance.resubmitBatchesAsync(batchIds, true).then((batches) => {
            if (!!batches && batches.lengh > 0) {
                return batches[0];
            }
            
            return null;
        })
    };
    
    useEffect(() => {
        _ = getAllAsync();
    }, []);
    
    const submenu = !!partner?.id ? (<PartnerSubMenu partner={partner} selection="overview" />) : null;
    
    const resultsElements = pagerController?.mapLineItems(results, (result, index) => {
        const seNumber = result.txnId;
        const seElement = !!seNumber ? (<span className="se-number">{seNumber}</span>) : (<span className="bad-se-number" onClick={() => promptForSeEdit(result, index)}>No SE Number Submitted</span>);
        
        if (index === 0) console.warn(JSON.stringify(result, null, 4));
        
        return (<tr key={"result-" + index}>
            <td><Link to={"/partners/" + partnerId + "/merchants/00000000-0000-0000-0000-000000000000/batch/" + result.batchId}>{result.batchId}</Link></td>
            <td>{seElement}</td>
            <td><DateTime value={result.created} /></td>
        </tr>);
    }) || null;
    
    const resultsTable = results?.length > 0 ?
        (<table className="table table-x-large" width={"100%"}>
            <thead>
            <tr>
                <th>Batch ID</th>
                <th>SE Number</th>
                <th>Created</th>
            </tr>
            </thead>
            <tbody>{resultsElements}</tbody>
        </table>) :
        null;
    
    return (
        <MasterScreenMain selection="partners">
            <div className="pad" id="partner-batch-results">
                <h1>
                    <FontAwesomeIcon icon={faAddressCard} />
                    {partner?.name}
                </h1>

                <div className="details-body" id="batch-results">
                    { submenu }

                    <div className="pad">
                        <h2>
                            <BackButton />
                            {partner?.name} American Express Insights
                            <RefreshButton onClick={getAmexResultsAsync} />
                        </h2>

                        <div className={"amex"}>
                            <span><svg width="100" height="24" enable-background="new 0 0 78 50" version="1.1" viewBox="0 0 780 420"><path d="m575.61 145.11l-15.092 35.039h30.266l-15.174-35.039zm-174.15 21.713c2.845-1.422 4.52-4.515 4.52-8.356 0-3.764-1.76-6.49-4.604-7.771-2.591-1.42-6.577-1.584-10.399-1.584h-27v19.523h26.638c4.266 1e-3 7.831-0.059 10.845-1.812zm-345.97-21.713l-14.921 35.039h29.932l-15.011-35.039zm694.7 224.47h-42.344v-18.852h42.173c4.181 0 7.109-0.525 8.872-2.178 1.667-1.473 2.609-3.555 2.592-5.732 0-2.562-1.062-4.596-2.68-5.813-1.588-1.342-3.907-1.953-7.726-1.953-20.588-0.67-46.273 0.609-46.273-27.211 0-12.75 8.451-26.172 31.461-26.172h43.677v-17.492h-40.58c-12.246 0-21.144 2.81-27.443 7.181v-7.181h-60.022c-9.597 0-20.863 2.279-26.191 7.181v-7.181h-107.19v7.181c-8.529-5.897-22.925-7.181-29.565-7.181h-70.702v7.181c-6.747-6.262-21.758-7.181-30.902-7.181h-79.127l-18.104 18.775-16.959-18.775h-118.2v122.68h115.97l18.655-19.076 17.575 19.076 71.484 0.06v-28.859h7.03c9.484 0.146 20.67-0.223 30.542-4.311v33.106h58.962v-31.976h2.844c3.628 0 3.988 0.146 3.988 3.621v28.348h179.12c11.372 0 23.26-2.786 29.841-7.853v7.853h56.817c11.822 0 23.369-1.588 32.154-5.653v-22.853c-5.324 7.462-15.707 11.245-29.751 11.245zm-363.58-28.967h-27.36v29.488h-42.618l-27-29.102-28.058 29.102h-86.854v-87.914h88.19l26.976 28.818 27.89-28.818h70.064c17.401 0 36.952 4.617 36.952 28.963 0 24.422-19.016 29.463-38.182 29.463zm131.56-3.986c3.097 4.291 3.544 8.297 3.634 16.047v17.428h-22.016v-10.998c0-5.289 0.533-13.121-3.544-17.209-3.2-3.148-8.086-3.9-16.088-3.9h-23.432v32.107h-22.031v-87.914h50.62c11.105 0 19.188 0.473 26.384 4.148 6.92 4.006 11.275 9.494 11.275 19.523-2e-3 14.031-9.769 21.189-15.541 23.389 4.878 1.725 8.866 4.818 10.739 7.379zm90.575-36.258h-51.346v15.982h50.091v17.938h-50.091v17.492l51.346 0.078v18.242h-73.182v-87.914h73.182v18.182zm56.344 69.731h-42.705v-18.852h42.535c4.16 0 7.109-0.527 8.957-2.178 1.507-1.359 2.591-3.336 2.591-5.73 0-2.564-1.174-4.598-2.676-5.818-1.678-1.34-3.993-1.947-7.809-1.947-20.506-0.674-46.186 0.605-46.186-27.213 0-12.752 8.363-26.174 31.35-26.174h43.96v18.709h-40.225c-3.987 0-6.579 0.146-8.783 1.592-2.405 1.424-3.295 3.535-3.295 6.322 0 3.316 2.04 5.574 4.797 6.549 2.314 0.771 4.797 0.996 8.533 0.996l11.805 0.309c11.899 0.273 20.073 2.25 25.04 7.068 4.266 4.232 6.559 9.578 6.559 18.625-2e-3 18.913-12.335 27.742-34.448 27.742zm-170.06-68.313c-2.649-1.508-6.559-1.588-10.461-1.588h-27.001v19.744h26.64c4.265 0 7.892-0.145 10.822-1.812 2.842-1.646 4.543-4.678 4.543-8.438s-1.701-6.482-4.543-7.906zm244.99-1.59c-3.988 0-6.641 0.145-8.873 1.588-2.314 1.426-3.202 3.537-3.202 6.326 0 3.314 1.953 5.572 4.794 6.549 2.315 0.771 4.796 0.996 8.448 0.996l11.887 0.303c11.99 0.285 19.998 2.262 24.879 7.08 0.889 0.668 1.423 1.42 2.034 2.174v-25.014h-39.965l-2e-3 -2e-3zm-352.65 0h-28.59v22.391h28.336c8.424 0 13.663-4.006 13.667-11.611-4e-3 -7.688-5.497-10.78-13.413-10.78zm-190.81 0v15.984h48.136v17.938h-48.136v17.49h53.909l25.047-25.791-23.983-25.621h-54.973zm140.77 61.479v-70.482l-33.664 34.674 33.664 35.808zm-138.93-141.15v15.148h183.19l-0.085-32.046h3.545c2.483 0.083 3.205 0.302 3.205 4.229v27.818h94.748v-7.461c7.642 3.924 19.527 7.461 35.168 7.461h39.86l8.531-19.522h18.913l8.342 19.522h76.811v-18.544l11.629 18.543h61.555v-122.58h-60.915v14.477l-8.53-14.477h-62.507v14.477l-7.833-14.477h-84.434c-14.135 0-26.555 1.89-36.591 7.158v-7.158h-58.268v7.158c-6.387-5.43-15.089-7.158-24.762-7.158h-212.87l-14.282 31.662-14.668-31.662h-67.047v14.477l-7.367-14.477h-57.18l-26.553 58.284v46.621l39.264-87.894h32.579l37.29 83.217v-83.217h35.789l28.695 59.625 26.362-59.625h36.507v87.894h-22.475l-0.082-68.837-31.796 68.837h-19.252l-31.877-68.898v68.898h-44.6l-8.425-19.605h-45.654l-8.512 19.605h-23.814v17.682h37.466l8.447-19.523h18.914l8.425 19.523h73.713v-14.927l6.579 14.989h38.266l6.58-15.214zm288.67-80.176c7.085-7.015 18.188-10.25 33.298-10.25h21.227v18.833h-20.782c-7.998 0-12.521 1.14-16.871 5.208-3.74 3.7-6.304 10.696-6.304 19.908 0 9.417 1.955 16.206 6.028 20.641 3.376 3.478 9.513 4.533 15.283 4.533h9.851l30.902-69.12h32.853l37.124 83.134v-83.133h33.386l38.543 61.213v-61.213h22.46v87.891h-31.072l-41.562-65.968v65.968h-44.656l-8.532-19.605h-45.55l-8.278 19.605h-25.66c-10.657 0-24.151-2.258-31.793-9.722-7.707-7.462-11.713-17.571-11.713-33.553-4e-3 -13.037 2.389-24.953 11.818-34.37zm-45.101-10.249h22.372v87.894h-22.372v-87.894zm-100.87 0h50.432c11.203 0 19.464 0.285 26.553 4.21 6.936 3.926 11.095 9.658 11.095 19.46 0 14.015-9.763 21.254-15.448 23.429 4.796 1.75 8.896 4.841 10.849 7.401 3.096 4.372 3.629 8.277 3.629 16.126v17.267h-22.115l-0.083-11.084c0-5.29 0.528-12.896-3.461-17.122-3.203-3.09-8.088-3.763-15.983-3.763h-23.538v31.97h-21.927l-3e-3 -87.894zm-88.393 0h73.249v18.303h-51.32v15.843h50.088v18.017h-50.088v17.553h51.32v18.177h-73.249v-87.893z"></path></svg></span>
                            <p>
                                This is an American Express forensics page
                            </p>
                        </div>
                        
                        <div className="section-wrap" id="batch-result-details">
                            { resultsTable }
                        </div>
                        <Pager controller={pagerController} items={results} />
                        
                    </div>
                </div>
            </div>
            
            <DialogBox controller={seController} onOkay={onSeUpdatedAsync}>
                
            </DialogBox>
        </MasterScreenMain>);
};

export default AmericanExpressScreen;
